// OAuth 2.1 authorize-URL builder + redirect helper. Shared by the header
// "Sign in" button, AuthGuard's unauth redirect, and the session-expired modal.
//
// Encapsulates PKCE verifier/challenge/state generation, issuer resolution,
// and window.location.assign so callers don't fork on this every time.
//
// Adapted from Workbench origin/main@60e779e:src/utils/oauth.js — dropped the
// getApiBaseUrl() fallback (Next's auth config comes exclusively from
// /config.json) and added returnTo plumbing.

import {
  buildAuthorizeUrl,
  deriveCodeChallenge,
  generateCodeVerifier,
  generateState,
  persistPkce,
} from './pkce.js'

const DEFAULT_CLIENT_ID = 'next-webapp'

export async function redirectToOAuthSignIn(authConfig, { returnTo } = {}) {
  if (!authConfig?.issuer) {
    throw new Error('No OAuth issuer configured; set auth.issuer in /config.json')
  }

  const verifier = generateCodeVerifier()
  const challenge = await deriveCodeChallenge(verifier)
  const state = generateState()
  persistPkce(state, verifier, returnTo || null)

  const url = buildAuthorizeUrl({
    issuer: authConfig.issuer,
    clientId: authConfig.clientId || DEFAULT_CLIENT_ID,
    redirectUri: `${window.location.origin}/oauth/callback`,
    state,
    codeChallenge: challenge,
    scope: authConfig.scope || '',
    resource: authConfig.resource || authConfig.issuer,
  })
  window.location.assign(url)
}
